export default {"src":"/_next/static/media/Ollie_Site_Icons_working_final_PlantTree.02308f92.svg","height":70,"width":69,"blurWidth":0,"blurHeight":0};